import React, { useContext } from "react";
import { useAuth } from "hooks/Auth";
import { fromSqlDateTime } from "helpers/Date";
import Label from "components/FormElements/Label";
import { ContentContext } from "context/Content";
import { Field, useFormikContext } from "formik";

export default function UrlField(props) {
    const auth = useAuth();
    const { state } = useContext(ContentContext);
    const { setFieldValue } = useFormikContext();

    if (state.loading) {
        return (
            <div>
                <Label>URLs</Label>
                <div className="mt-1 h-20 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    if (!state.content.uuid) {
        return (
            <div>
                <Label>URLs</Label>
                <div className="text-xs text-gray-500">
                    URLs are generated after saving.
                </div>
            </div>
        );
    }

    return (
        <div>
            <Label>URLs</Label>
            <div className="space-y-2 text-xs">
                <div>
                    <a
                        href={`${auth.publication.uri}/${state.content.uuid}`}
                        className="text-green-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {auth.publication.uri}/{state.content.uuid}
                    </a>
                </div>
                <div>
                    <a
                        href={`${auth.publication.uri}/article/${
                            state.content.published_at
                                ? fromSqlDateTime(
                                      state.content.published_at
                                  ).toFormat("yyyy/LL")
                                : fromSqlDateTime(
                                      state.content.created_at
                                  ).toFormat("yyyy/LL")
                        }/${state.content.title_url}`}
                        className="text-green-600 underline"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {auth.publication.uri}/{state.content.type}/
                        {state.content.published_at
                            ? fromSqlDateTime(
                                  state.content.published_at
                              ).toFormat("yyyy/LL")
                            : fromSqlDateTime(
                                  state.content.created_at
                              ).toFormat("yyyy/LL")}
                        /{state.content.title_url}
                    </a>
                </div>
                {state.content.urls &&
                    state.content.urls.map((url) => (
                        <div key={`url-${url.slug}`}>
                            <a
                                href={`${auth.publication.uri}/${url.slug}`}
                                className="text-green-600 underline"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {auth.publication.uri}/{url.slug}
                            </a>
                        </div>
                    ))}
            </div>
            <div className="mt-1 flex rounded-md shadow-sm">
                <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3 text-gray-500 sm:text-sm">
                    {auth.publication.uri}/
                </span>
                <Field
                    onChange={(e) => {
                        const newVal = e.target.value
                            .toLowerCase()
                            .replace(/ {2,}/g, " ")
                            .replace(/ /g, "-")
                            .replace(/[^a-z0-9-]/g, "");

                        setFieldValue("custom_url", newVal);
                    }}
                    type="text"
                    name="custom_url"
                    id="custom_url"
                    className="block w-full min-w-0 flex-1 rounded-none rounded-r-md border-gray-300 px-3 py-2 focus:border-green-500 focus:ring-green-500 sm:text-sm"
                    placeholder="my/custom/path"
                    as="input"
                    autoComplete="of"
                />
            </div>
        </div>
    );
}
